import React, { useState, useEffect } from "react";
import { Modal } from "antd";
import { HiPlus } from "react-icons/hi";
import { Switch } from "antd";
import {
  DropdownJobtype,
  DropdownIf,
  DropdownState,
  DropdownValue,
  DropdownDo,
} from "./dropdownIf";
import AddDropDownoption from "./addDropdownOption";
import { toast } from "react-toastify";
import Cookies from "universal-cookie";
import { loaderReducer } from "../../../components/toolkit/loader";
import {
  createSurveyTemplate,
  List,
  Update,
} from "../../../functions/surveyTemplate";
import { useDispatch } from "react-redux";

const SurveyTemplate = ({
  arg: {
    setIsModalOpen,
    isModalOpen,
    handleOk,
    handleCancel,
    customImageUpload,
    setCustomImageUpload,
    customTextField,
    setCustomTextField,
    customDropDown,
    setCustomDropDown,
    isEdit,
    editData,
    fetchData,
    jobTypeList,
    setJobTypeList,
  },
}) => {
  const cookies = new Cookies();
  const token = cookies.get("token");
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({
    title: "",
    tranId: "",
    jobType: "",
    id: "",
  });
  const [dropdowns, setDropDowns] = useState([]);
  const [ifDoQuestions, setIfDoQuestions] = useState([]);
  const [isChecked, setIsChecked] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  //-----------Generate UUID----------------------
  function generateCustomUUID() {
    let uuid = "";
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    for (let i = 0; i < 24; i++)
      uuid += characters.charAt(Math.floor(Math.random() * characters.length));
    return uuid;
  }

  //-----------text field added----------------------
  const addCustomTextField = () => {
    const newUuid = generateCustomUUID();
    const newUniqueid = generateCustomUUID();
    setDropDowns([
      ...dropdowns,
      {
        uuid: newUuid,
        type: "text",
        question: "",
        require_response: "false",
        make_conditional: "false",
        conditions: [
          {
            uuid: newUniqueid,
            if: "",
            state: "",
            value: "",
            do: "",
            doType: "",
            questionId: "",
          },
        ],
      },
    ]);
    // setCustomTextField([
    //   ...customTextField,
    //   { qestion_title: "", required: true, makeconditional: false },
    // ]);
  };
  const removeCustomField = (index) => {
    const updatedDropDowns = [...dropdowns];
    updatedDropDowns.splice(index, 1);
    setDropDowns(updatedDropDowns);
    // const updatedCustomTextField = [...customTextField];
    // updatedCustomTextField.splice(index, 1);
    // setCustomTextField(updatedCustomTextField);
  };
  const handleSwitchCustomTextField = (index) => {
    const updatedCustomTextField = [...customTextField];
    updatedCustomTextField[index].makeconditional =
      !updatedCustomTextField[index].makeconditional; // toggle the makeconditional property
    setCustomTextField(updatedCustomTextField);
  };
  //------------------dropdown added-------------------

  const addCustomDropDown = () => {
    const newUuid = generateCustomUUID();
    const newUniqueid = generateCustomUUID();
    setDropDowns([
      ...dropdowns,
      {
        uuid: newUuid,
        type: "dropdown",
        sort: "",
        question: "",
        options: [""],
        require_response: "false",
        make_conditional: "false",
        conditions: [
          {
            uuid: newUniqueid,
            if: "",
            state: "",
            value: "",
            do: "",
            doType: "",
            questionId: "",
          },
        ],
      },
    ]);
    // setCustomDropDown([
    //   ...customDropDown,
    //   {
    //     question_title: "",
    //     required: true,
    //     makeconditional: false,
    //     options: [{ option: "" }, { option: "" }],
    //   },
    // ]);
  };
  //----------image upload functionality------------
  const addCustomImageUpload = () => {
    const newUuid = generateCustomUUID();
    setDropDowns([
      ...dropdowns,
      {
        uuid: newUuid,
        type: "image",
        sort: "",
        upload_image: "",
        foot_photo: "",
        geotag: "",
        include_image_upload_field: "false",
      },
    ]);
    // setCustomImageUpload([
    //   ...customImageUpload,
    //   {
    //     upload_image: "",
    //     upload_title: "",
    //     geotag: "",
    //     checked: false,
    //   },
    // ]);
  };

  const removeCustomImageUpload = (index) => {
    const updatedCustomImageUpload = [...customImageUpload];
    updatedCustomImageUpload.splice(index, 1);
    setCustomImageUpload(updatedCustomImageUpload);
  };

  const handleSwitchChangeImageUpload = (index) => {
    const updatedCustomImageUpload = [...customImageUpload];
    updatedCustomImageUpload[index].checked =
      updatedCustomImageUpload[index].checked == "true" ? false : true;
    setCustomImageUpload(updatedCustomImageUpload);
  };

  const handleGeotagChange = (index, value) => {
    const updatedGeotag = [...customImageUpload];
    updatedGeotag[index].geotag = value;
    setCustomImageUpload(updatedGeotag);
  };

  const handleUploadTitleChange = (index, value) => {
    const updatedUploadTitle = [...customImageUpload];
    updatedUploadTitle[index].upload_title = value;
    setCustomImageUpload(updatedUploadTitle);
  };

  const handleUploadImageChange = (index, e) => {
    const { name, value } = e.target;
    const updatedDropDown = [...dropdowns];
    updatedDropDown[index][name] = e.target.files[0];
    setDropDowns(updatedDropDown);
  };

  function generateCustomTranId() {
    let tranId = "";
    const characters = "0123456789";
    for (let i = 0; i < 5; i++)
      tranId += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    return tranId;
  }
  // SO13482
  const handleSelectChange = (index, conditionIndex, state, value) => {
    const updatedDropDown = [...dropdowns];
    if (state === "do") {
      dropdowns.map((dropdown) => {
        if (value === dropdown.question) {
          updatedDropDown[index]["conditions"][conditionIndex]["doType"] =
            dropdown.type;
          updatedDropDown[index]["conditions"][conditionIndex]["questionId"] =
            dropdown.uuid;
        } else if (value === dropdown.foot_photo) {
          updatedDropDown[index]["conditions"][conditionIndex]["doType"] =
            dropdown.type;
          updatedDropDown[index]["conditions"][conditionIndex]["questionId"] =
            dropdown.uuid;
        }
      });
    }
    updatedDropDown[index]["conditions"][conditionIndex][state] = value;
    setDropDowns(updatedDropDown);
  };

  const handlejobTypeSelectChange = (state, value) => {
    
    setFormData((prevState) => ({
      ...prevState,
      [state]: value,
    }));
  };

  const handleSwitchChange = (index, type) => {
    const updatedDropDown = [...dropdowns];
    updatedDropDown[index][type] =
      updatedDropDown[index][type] === "true" ? "false" : "true";
    setDropDowns(updatedDropDown);

    if (
      type === "make_conditional" &&
      updatedDropDown[index][type] === "false"
    ) {
      const updatedDropDown = [...dropdowns];
      updatedDropDown[index]["if"] = "";
      updatedDropDown[index]["state"] = "";
      updatedDropDown[index]["value"] = "";
      updatedDropDown[index]["do"] = "";

      setDropDowns(updatedDropDown);
      getQuestion();
    }
  };

  const inputHandler = (index, type, e, isChecked) => {
    const { name, value } = e.target;
    const updatedDropDown = [...dropdowns];
    updatedDropDown[index][name] = value;
    setDropDowns(updatedDropDown);
  };

  const handleCheckboxChange = (e, index) => {
    const isChecked = e.target.checked; // Boolean: true if checked, false if not
    setIsChecked(e.target.checked); // Set the state to the checkbox's checked value
    inputHandler(index, "geotag", e, isChecked); // Pass the boolean to the handler
  };

  const inputHandlerCondition = (index, conditionIndex, type, e) => {
    const { name, value } = e.target;
    const updatedDropDown = [...dropdowns];
    updatedDropDown[index]["conditions"][conditionIndex][name] = value;
    setDropDowns(updatedDropDown);
  };

  const submitForm = async () => {
    formData["customSurvey"] = dropdowns;

    if (!isEdit) {
      dispatch(loaderReducer(true));
      const newTranId = generateCustomTranId();
      // formData['tranId'] = `SO${newTranId}`;
      await createSurveyTemplate(token, formData)
        .then((res) => {
          toast.success(`${res.data.message}`);
          setDropDowns([]);
          setFormData({
            title: "",
            tranId: "",
            jobType: "",
            id: "",
          });
          fetchData();
          dispatch(loaderReducer(false));
        })
        .catch((err) => {
          console.log(err, "err");
          dispatch(loaderReducer(false));
          toast.error(err.message);
        });
    } else {
      dispatch(loaderReducer(true));
      try {
        await Update(formData.id, token, formData)
          .then((res) => {
            dispatch(loaderReducer(false));
            toast.success(`${res.data.message}`);
            setDropDowns([]);
            setFormData({
              title: "",
              tranId: "",
              jobType: "",
              id: "",
            });
            fetchData();
          })
          .catch((err) => {
            dispatch(loaderReducer(false));
            toast.error(`Getting error ${err}`);
          });
      } catch (error) {
        toast.error(error);
        dispatch(loaderReducer(false));
      }
    }
    setIsModalOpen(false);
  };

  const closePopup = () => {
    setDropDowns([]);
    setFormData({
      title: "",
      tranId: "",
      jobType: "",
      id: "",
    });
    setIsModalOpen(false);
  };

  useEffect(() => {
    if (isEdit === true && editData && editData._id) {
      setFormData({
        title:
          editData.title !== undefined && editData.title.trim() !== ""
            ? editData.title
            : "",
        tranId: editData.tranId,
        jobType:
          editData.jobType !== undefined && editData.jobType.trim() !== ""
            ? editData.jobType
            : "",
        id: editData._id,
      });

      setDropDowns(editData.customSurvey);
    } else if (!isEdit) {
      setFormData({
        title: "",
        tranId: "",
        jobType: "",
        id: "",
      });
      setDropDowns([]);
    }
  }, [isEdit, editData]);

  const getQuestion = () => {
    dropdowns.map((dropdown) => {
      if (dropdown?.question) {
        // const extractedQuestions = dropdowns.filter(dropdown => dropdown.question).map((dropdown, index) =>
        // ({ key: dropdown.uuid, value: dropdown.question }));

        const extractedQuestions = dropdowns.map((item) => {
          if (item.type === "dropdown" || item.type === "text") {
            return { key: item.uuid, value: item.question };
          } else if (item.type === "image") {
            return { key: item.uuid, value: item.foot_photo };
          }
        });

        setIfDoQuestions(extractedQuestions);
      }
    });
  };

  const addNewCondition = (dropDownIndex) => {
    const newUuid = generateCustomUUID();
    const updatedDropDown = [...dropdowns];
    const conditions = updatedDropDown[dropDownIndex]["conditions"];
    const lastOptionKey = Math.max(
      ...Object.keys(conditions).map((key) => parseInt(key, 10))
    );
    const nextKey = lastOptionKey + 1;
    updatedDropDown[dropDownIndex]["conditions"] = [
      ...conditions,
      {
        uuid: newUuid,
        if: "",
        state: "",
        value: "",
        do: "",
        doType: "",
        questionId: "",
      },
    ];
    setDropDowns(updatedDropDown);
  };

  useEffect(() => {
    getQuestion();
  }, [dropdowns]);

  return (
    <div>
      <Modal
        title=" "
        open={isModalOpen}
        onOk={() =>
          handleOk(formData, dropdowns, setDropDowns, setFormData, isEdit)
        }
        onCancel={() => handleCancel(setDropDowns, setFormData)}
        width={"60%"}
        footer={null}
      >
        <div>
          <div>
            <div className="tupdate mt-3">
              {isEdit ? "Update" : "Create"} Survey & Questionnaire Templates
            </div>
            <div className="row mt-3">
              <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                Template Title
              </div>
              <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  value={formData.title}
                  onChange={(e) => handleChange(e)}
                  placeholder="New Install Survey"
                  required
                />
              </div>
            </div>
            <div className="row mt-2">
              <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                Job Type
              </div>
              <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                <DropdownJobtype
                  jobTypeList={jobTypeList}
                  setJobTypeList={setJobTypeList}
                  jobTypeDetail={formData.jobType}
                  onSelectChange={(value) =>
                    handlejobTypeSelectChange("jobType", value)
                  }
                />
              </div>
            </div>
            <div className="tupdate mt-3">Add Custom Survey Fields</div>

            {/* buttons */}
            <div className="d-flex gap-2 mt-2" style={{ color: "#414C60" }}>
              <div
                className="contd "
                style={{ width: "11rem" }}
                onClick={addCustomTextField}
              >
                Add Text Field
                <span>
                  <HiPlus size={20} />
                </span>
              </div>
              <div
                className="contd"
                style={{ width: "14rem" }}
                onClick={addCustomDropDown}
              >
                Add Dropdown Field
                <span>
                  <HiPlus size={20} />
                </span>
              </div>
              <div
                className="contd "
                style={{ width: "11rem" }}
                onClick={addCustomImageUpload}
              >
                Add Image Field
                <span>
                  <HiPlus size={20} />
                </span>
              </div>
            </div>
          </div>

          {dropdowns &&
            dropdowns.map((dropdown, index) => (
              <>
                {dropdown?.type && dropdown.type === "dropdown" ? (
                  <AddDropDownoption
                    arg={{
                      index,
                      dropdowns,
                      dropdown,
                      setDropDowns,
                      addCustomDropDown,
                    }}
                  />
                ) : dropdown?.type && dropdown.type === "text" ? (
                  <div key={index}>
                    <hr />
                    <div className="tupdate mt-3">
                      Custom Text Field {index + 1}
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                        Question
                      </div>
                      <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                        <input
                          type="text"
                          className="form-control"
                          name="question"
                          value={dropdown.question}
                          onChange={(e) => inputHandler(index, "question", e)}
                          placeholder="Was Product 1 installed/serviced?"
                          required
                        />
                      </div>
                      <div className="mt-3 d-flex justify-content-between">
                        <div className="sub2head mt-2">Require Response</div>
                        <Switch
                          onChange={() =>
                            handleSwitchChange(index, "require_response")
                          }
                          defaultChecked={
                            dropdown.require_response === "true" ? true : false
                          }
                        />
                      </div>
                      <div className="mt-2 d-flex justify-content-between">
                        <div className="sub2head mt-2">Make Conditional</div>
                        <Switch
                          onChange={() =>
                            handleSwitchChange(index, "make_conditional")
                          }
                          defaultChecked={
                            dropdown.make_conditional === "true" ? true : false
                          }
                        />
                      </div>
                      {/* ---------dropdown------- */}
                      {dropdown.make_conditional === "true" && (
                        <div>
                          {Object.values(dropdown.conditions).map(
                            (condition, conditionIndex) => (
                              <>
                                <div className="row mt-2">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    IF
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <DropdownIf
                                      ifDetail={condition.if}
                                      DoValueDetail={condition.do}
                                      ifDoQuestions={ifDoQuestions}
                                      uuid={condition.uuid}
                                      onSelectChange={(value) =>
                                        handleSelectChange(
                                          index,
                                          conditionIndex,
                                          "if",
                                          value
                                        )
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="row mt-2">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    STATE
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <DropdownState
                                      stateDetail={condition.state}
                                      onSelectChange={(value) =>
                                        handleSelectChange(
                                          index,
                                          conditionIndex,
                                          "state",
                                          value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="row mt-2">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    VALUE
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    {/* <DropdownValue valueDetail={dropdown.value}  onSelectChange={(value) => handleSelectChange(index, 'value', value)} /> */}
                                    <input
                                      type="text"
                                      className="form-control"
                                      name="value"
                                      value={condition.value}
                                      onChange={(e) =>
                                        inputHandlerCondition(
                                          index,
                                          conditionIndex,
                                          "value",
                                          e
                                        )
                                      }
                                      placeholder="Enter Value"
                                      required
                                    />
                                  </div>
                                </div>
                                {/* -- */}
                                <div className="row mt-2 pb-2 border-bottom">
                                  <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                                    DO
                                  </div>
                                  <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                                    <DropdownDo
                                      doDetail={condition.do}
                                      ifValueDetail={condition.if}
                                      ifDoQuestions={ifDoQuestions}
                                      uuid={condition.uuid}
                                      onSelectChange={(value) =>
                                        handleSelectChange(
                                          index,
                                          conditionIndex,
                                          "do",
                                          value
                                        )
                                      }
                                    />
                                  </div>
                                </div>
                              </>
                            )
                          )}

                          <div className="d-flex justify-content-end mt-3">
                            <div
                              className="contd"
                              style={{ width: "14rem" }}
                              onClick={() => addNewCondition(index)}
                            >
                              Add Condition
                              <span>+</span>
                            </div>
                          </div>
                        </div>
                      )}
                      <div
                        className="editbtn mt-2"
                        onClick={() => removeCustomField(index)}
                      >
                        Remove Custom Text Field
                      </div>
                    </div>
                  </div>
                ) : dropdown?.type && dropdown.type === "image" ? (
                  <div className="row mt-3" key={index}>
                    <hr />
                    <div className="tupdate ">
                      Custom Image Upload {index + 1}
                    </div>
                    <div className="row mt-3">
                      <div className="row position-relative">
                        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                          Upload Title
                        </div>
                        <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                          {/* <input
                            type="file"
                            accept="image/*"
                            name="upload_image"
                            onChange={(e) => handleUploadImageChange(index, e)}
                            required
                          /> */}
                          <input
                            className="form-control"
                            placeholder="8 Foot Photo"
                            name="foot_photo"
                            value={dropdown.foot_photo}
                            onChange={(e) =>
                              inputHandler(index, "foot_photo", e)
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="row position-relative">
                        {/* <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                          Geotag (optional)
                        </div>
                        <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                          <input
                            className="form-control"
                            placeholder="Type here"
                            name="geotag"
                            value={dropdown.geotag}
                            onChange={(e) => inputHandler(index, "geotag", e)}
                          />
                        </div> */}
                        <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                          Geotag (optional)
                        </div>
                        <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                          <input
                            type="checkbox"
                            placeholder="Type here"
                            name="geotag"
                            value={isChecked ? false : true}
                            checked={isChecked}
                            onChange={(e) => handleCheckboxChange(e, index)}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="mt-2 d-flex justify-content-between">
                      <div className="sub2head mt-2">
                        Include Image Upload Field
                      </div>
                      <Switch
                        onChange={() =>
                          handleSwitchChange(
                            index,
                            "include_image_upload_field"
                          )
                        }
                        defaultChecked={
                          dropdown.include_image_upload_field === "true"
                            ? true
                            : false
                        }
                      />
                    </div>
                    <div className="mt-2 d-flex justify-content-end">
                      <div
                        className="mt-2 editbtn"
                        onClick={() => removeCustomField(index)}
                      >
                        Remove Custom Image Upload
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </>
            ))}

          {/* ------------------Custom Text Field 1----------- */}
          {/* {customTextField.map((item, i) => (
            <div key={i}>
              {console.log("item=>", item.makeconditional, i)}
              <hr />
              <div className="tupdate mt-3">Custom Text Field {i + 1}</div>
              <div className="row mt-2">
                <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                  Question
                </div>
                <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                  <input
                    type="text"
                    className="form-control"
                    name="title"
                    placeholder="Was Product 1 installed/serviced?"
                    required
                  />
                </div>
                <div className="mt-3 d-flex justify-content-between">
                  <div className="sub2head mt-2">Require Response</div>
                  <Switch defaultChecked={true} />
                </div>
                <div className="mt-2 d-flex justify-content-between">
                  <div className="sub2head mt-2">Make Conditional</div>
                  <Switch
                    defaultChecked={item.makeconditional}
                    onChange={() => handleSwitchCustomTextField(i)}
                  />
                </div>
                {item.makeconditional && (
                  <div>
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                        IF
                      </div>
                      <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                        <DropdownIf />
                      </div>
                    </div>

                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                        STATE
                      </div>
                      <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                        <DropdownState />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                        VALUE
                      </div>
                      <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                        <DropdownValue />
                      </div>
                    </div>
                    <div className="row mt-2">
                      <div className="col-lg-3 col-md-5 col-sm-12 sub2head">
                        DO
                      </div>
                      <div className="col-lg-9 col-md-7 col-sm-12 position-relative">
                        <DropdownDo />
                      </div>
                    </div>
                  </div>
                )}
                <div className="editbtn mt-2" onClick={removeCustomTextField}>
                  Remove Custom Text Field
                </div>
              </div>
            </div>
          ))} */}

          {/* ------------------Custom Dropdown Field 1----------- */}

          {/* <AddDropDownoption
            arg={{ customDropDown, setCustomDropDown, addCustomDropDown }}
          /> */}

          {/* --------------add custom image-------------------------- */}
          {/* {customImageUpload.map((item, index) => (
            <div className="row mt-3" key={index}>
              <hr />
              <div className="tupdate ">Custom Image Upload {index + 1}</div>
              <div className="row mt-3">
                <div className="row position-relative">
                  <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                    Upload Title
                  </div>
                  <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                    <input
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleUploadImageChange(index, e)}
                    />
                    <input
                      className="form-control"
                      placeholder="8 Foot Photo"
                      value={item.upload_title}
                      onChange={(e) =>
                        handleUploadTitleChange(index, e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="row mt-2">
                <div className="row position-relative">
                  <div className="col-lg-2 col-md-4 col-sm-12 sub2head">
                    Geotag (optional)
                  </div>
                  <div className="col-lg-10 col-md-8 col-sm-12 d-flex gap-2 position-relative">
                    <input
                      className="form-control"
                      placeholder="Type here"
                      value={item.geotag}
                      onChange={(e) =>
                        handleGeotagChange(index, e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>
              <div className="mt-2 d-flex justify-content-between">
                <div className="sub2head mt-2">Include Image Upload Field</div>
                <Switch
                  defaultChecked={item.checked === "true" ? true : false}
                  onChange={() => handleSwitchChangeImageUpload(index)}
                />
              </div>
              <div className="mt-2 d-flex justify-content-end">
                <div
                  className="mt-2 editbtn"
                  onClick={() => removeCustomImageUpload(index)}
                >
                  Remove Custom Image Upload
                </div>
              </div>
            </div>
          ))} */}
          {/* button */}
          <div className="d-flex mt-4 gap-2 justify-content-end">
            <div className="contd" onClick={closePopup}>
              Exit without Saving
            </div>{" "}
            <div
              onClick={submitForm}
              className="contd"
              style={{ backgroundColor: "#1C449C", color: "white" }}
            >
              Save Changes
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default SurveyTemplate;
